import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";

const ACF = () => {
  return (
    <main data-testid="acf-page" className="bg-ivory text-navy min-h-screen pt-24">
      <div className="container-editorial py-20 md:py-28 max-w-3xl">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-muteText hover:text-navy mb-12"
        >
          <ArrowLeft size={14} /> Torna alla home
        </Link>

        <p className="overline mb-6">Tutela del cliente</p>
        <h1 className="display-2 mb-10">Arbitro per le Controversie Finanziarie</h1>

        <div className="space-y-6 text-muteText leading-relaxed text-base md:text-lg">
          <p>
            Il Cliente può presentare ricorso all'Arbitro per le Controversie
            Finanziarie (ACF), istituito presso la CONSOB, per la risoluzione
            extragiudiziale delle controversie tra investitori (diversi dai clienti
            professionali) e i consulenti finanziari autonomi e le società di
            consulenza finanziaria di cui, rispettivamente, agli articoli 18-bis e
            18-ter del TUF, relative alla violazione da parte di questi ultimi degli
            obblighi di diligenza, correttezza, informazione e trasparenza
            nell'esercizio dell'attività disciplinata dalla Parte II del TUF, incluse
            le controversie oggetto del Regolamento (UE) n. 524/2013.
          </p>
          <p>
            Non rientrano nell'ambito dell'operatività dell'Arbitro le controversie
            che implicano la richiesta di somme di denaro per un importo superiore
            a Euro cinquecentomila. Sono esclusi dalla cognizione dell'Arbitro i
            danni che non sono conseguenza immediata e diretta dell'inadempimento o
            della violazione da parte dell'intermediario degli obblighi sopra
            descritti e quelli che non hanno natura patrimoniale.
          </p>
          <p>
            Il diritto di ricorrere all'ACF è irrinunciabile e sempre esercitabile
            anche in presenza di clausole di devoluzione delle controversie ad altri
            organismi di risoluzione extragiudiziale contenute nel contratto.
          </p>
        </div>

        <div className="mt-12 border-t border-line pt-10">
          <p className="text-sm text-muteText mb-4">
            Per maggiori informazioni fare riferimento al sito ufficiale ACF —
            CONSOB:
          </p>
          <a
            data-testid="acf-link"
            href="https://www.acf.consob.it/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            Visita acf.consob.it <ExternalLink size={16} />
          </a>
        </div>

        <p className="text-xs tracking-[0.22em] uppercase text-muteText mt-16">
          Ultimo aggiornamento: dicembre 2025
        </p>
      </div>
    </main>
  );
};

export default ACF;
